<template>
  <base-nav
    class="navbar-top navbar-dark"
    id="navbar-main"
    :show-toggle-button="false"
    expand
  >
    <form
      class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"
    >
      <div class="form-group mb-0"></div>
    </form>

    <ul class="navbar-nav align-items-center d-none d-md-flex">
      
      <li class="nav-item">
        <a class="nav-link p-2" href="#" @click.prevent>
          <i class="fa fa-bell fa-lg" style="color: white; font-size: 1.2rem;"></i>
        </a>
      </li>
      
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link p-0">
          <div
            class="d-flex align-items-center px-3 py-1"
            slot="title"
            style="
              background-color: #ffffff;
              color: #f4642c;
              font-weight: 600;
              border-radius: 20px;
              box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            "
          >
            <i class="fa fa-user-circle" style="font-size: 1rem; margin-right: 5px;"></i>
            {{ memberName }}
            <i class="fa fa-caret-down ml-2" style="font-size: 0.8rem;"></i>
          </div>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
            </div>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item" @click.prevent="changePassword">
              <i class="fa fa-lock mr-2"></i>
              <span>Change Password</span>
            </a>
            <a href="#" class="dropdown-item" @click="logout">
              <i class="fa fa-running mr-2"></i>
              <span>Logout</span>
            </a>
          </template>
        </base-dropdown>
      </li>
    </ul>
      <!-- Modal component added here -->
      <change-password :data="memberData" :visible="showModal" @close="showModal = false" />
    </base-nav>
    </template>
<script>
import secureStorage from '../controllers/secureStorage';
import ChangePassword from './ChangePassword.vue';

export default {
  components: {
    ChangePassword
  },
  data() {
    return {
      memberData: null,
      activeNotifications: false,
      showMenu: false,
      showModal: false
    };
  },
  created() {
    this.memberData = secureStorage.getItem('clpMemberData') || null;
  },
  computed: {
    memberName() {
      if (this.memberData && this.memberData.first_name && this.memberData.last_name) {
        return this.memberData.first_name + ' ' + this.memberData.last_name;
      }
      return 'Guest';
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },

    logout() {
      console.log('Logout');
      const siteName = secureStorage.getItem('clpSitePageSettings').siteName;
      // secureStorage.removeItem('clpSitePageSettings');
      secureStorage.removeItem('clpSitePageAccessToken');
      secureStorage.removeItem('clpMemberData');

      this.$notification.success({
        message: 'Successfully logged out.'
      });

      setTimeout(() => {
        this.$router.push({ name: 'MemberLogin', params: { siteName } });
      }, 1000);
    },
    async changePassword() {
      this.showModal = true;
    }
  }
};
</script>